import { render, staticRenderFns } from "./ConsultarEstablecimientos.vue?vue&type=template&id=28562986"
import script from "./ConsultarEstablecimientos.vue?vue&type=script&lang=js"
export * from "./ConsultarEstablecimientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports